module.exports = __webpack_public_path__ + "static/media/spine.8e989e31.svg";